import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()(() => {
    return {
        table: {
            minHeight: 180,
            maxHeight: 750,
        },
    }
})

export default useStyles
